var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c('content-block',{key:index,attrs:{"title":block.title,"content":block.content}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }